((document, window) => {
  const dataFabric = (context) => {
    const SERVER_DELAY = 60000;
    const WATCHER_INTERVAL = 5 * 60000;
    let completeActions = [];
    let globalActionsTotal = 0;
    let globalActionsTarget = 0;
    const globalActionsObservers = [];
    let lastCounterRequest = 0;
    let goals = [
      { id: 1, actions: 1, global: 0 },
      { id: 2, actions: 6, global: 0 },
      { id: 3, actions: 14, global: 0 },
      { id: 4, actions: 27, global: 0 },
      { id: 5, actions: 6, global: 100 },
      { id: 6, actions: 14, global: 200 },
      { id: 7, actions: 27, global: 500 },
      { id: 8, actions: 27, global: 1000 },
      { id: 9, actions: 27, global: 2000 },
      { id: 10, actions: 27, global: 5000 },
    ];
    let gifts = {
      attempts: [],
      gifts: [],
    };

    const getGlobalActionsCounter = () => globalActionsTotal;

    const setGlobalActionsCounter = (dataTotal, dataTarget) => {
      const total = parseInt(dataTotal ?? 0);
      const target = parseInt(dataTarget ?? 0);
      const changed =
        total != globalActionsTotal || target != globalActionsTarget;
      if (!changed) {
        return;
      }
      globalActionsTotal = total;
      globalActionsTarget = target;
      localStorage.setItem(
        "globalScore",
        JSON.stringify({
          total,
          target,
        })
      );
      // console.log(`Global Counter {total=${total}, target=${target}}`);
    };
    const emitUpdateGlobalCounter = () => {
      globalActionsObservers.forEach((cb) => {
        try {
          cb(getGlobalActionsCounter());
        } catch (e) {}
      });
    };
    const globalCounterServerListener = (() => {
      let on = false;
      let errorCount = 0;
      let handle = false;
      const update = async () => {
        const now = new Date().getTime();
        if (lastCounterRequest && now - lastCounterRequest < SERVER_DELAY) {
          handle = setTimeout(update, SERVER_DELAY);
          return;
        }
        // console.log("Listener is updating...");
        const YmdHi = new Date()
          .toISOString()
          .replace(/:\d+.\d+Z/, "")
          .replace(/\D/g, "");
        const request = async () => {
          try {
            lastCounterRequest = now;
            const response = await fetch(
              `/wp-json/mfa-blocks-actions2024/v1/completed-actions-counter/?v=${YmdHi}`
            );
            if (!response.ok) {
              return false;
            }
            const data = await response.json();
            if (!("total" in data)) {
              return false;
            }
            setGlobalActionsCounter(data.total, data.target);
          } catch (e) {}
          return true;
        };
        // Refresh only when the tab is active.
        if (!document.hidden) {
          const result = await request();
          if (result) {
            // console.log(`Listener success. Total = ${globalActionsTotal}`);
            emitUpdateGlobalCounter();
            errorCount = 0;
          } else {
            errorCount++;
            // console.error(`Listener failed. Error count = ${errorCount}`);
          }
        }
        if (on) {
          handle = setTimeout(
            update,
            WATCHER_INTERVAL + Math.min(10, errorCount) * SERVER_DELAY
          );
        }
      };
      const start = () => {
        if (on) {
          return;
        }
        on = true;
        // console.log("Listener started.");
        update();
      };
      const stop = () => {
        on = false;
        // console.log("Listener stopped.");
        if (handle) {
          clearTimeout(handle);
        }
      };
      return {
        start,
        stop,
      };
    })();

    const serverCompleteAction = (id) => {
      lastCounterRequest = new Date().getTime();
      fetch(`/wp-json/mfa-blocks-actions2024/v1/action/${id}/complete/`, {
        headers: {
          "content-type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          total: completeActions.length,
        }),
      }).then(async (response) => {
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        if (!("total" in data)) {
          return;
        }
        setGlobalActionsCounter(data.total, data.target);
      });
    };

    const emitUpdateAction = () => {
      window.dispatchEvent(
        new CustomEvent("mfa-actions-update-counter", {
          detail: completeActions.length,
        })
      );
    };
    /**
     * @param uint actionId Action ID.
     * @returns [bool success, bool isNew]
     */
    const completeAction = (actionId) => {
      const id = parseInt(actionId);
      if (isNaN(id) || id <= 0) {
        return [false, false];
      }
      const sa = localStorage.getItem("complete");
      const j = JSON.parse(sa);
      if (Array.isArray(j)) {
        completeActions = [...new Set(j)];
      }
      if (completeActions.indexOf(id) > -1) {
        return [true, false];
      }
      completeActions.push(id);
      emitUpdateAction();
      saveState();
      serverCompleteAction(id);
      return [true, true];
    };
    const getActionsCounter = () => completeActions.length;
    const isActionComplete = (actionId) =>
      completeActions.indexOf(parseInt(actionId)) > -1;
    const subscribeActionsCounter = (cb) => {
      window.addEventListener("mfa-actions-update-counter", (event) => {
        cb(event.detail || 0);
      });
      cb(getActionsCounter());
    };
    const subscribeGlobalActionsCounter = (cb) => {
      if (globalActionsObservers.indexOf(cb) !== -1) {
        return;
      }
      globalActionsObservers.push(cb);
      globalCounterServerListener.start();
      cb(getGlobalActionsCounter());
    };
    const unsubscribeGlobalActionsCounter = (cb) => {
      const index = globalActionsObservers.indexOf(cb);
      if (index !== -1) {
        globalActionsObservers.splice(index, 1);
      }
      if (!globalActionsObservers.length) {
        globalCounterServerListener.stop();
      }
    };

    const clearState = () => {
      completeActions = [];
      gifts = {
        attempts: [],
        gifts: [],
      };
      emitUpdateAction();
      saveState();
    };
    const loadState = () => {
      try {
        const sa = localStorage.getItem("complete");
        const j = JSON.parse(sa);
        if (Array.isArray(j)) {
          completeActions = [...new Set(j)];
        }
      } catch (e) {}
      emitUpdateAction();
      try {
        const score = localStorage.getItem("globalScore");
        const j = JSON.parse(score);
        if (typeof j === "object" && j.total) {
          globalActionsTotal = parseInt(j.total) || 0;
          globalActionsTarget = parseInt(j.target) || 0;
        }
      } catch (e) {}
      emitUpdateGlobalCounter();
      try {
        const data = localStorage.getItem("gifts");
        const j = JSON.parse(data);
        if (
          typeof j === "object" &&
          Array.isArray(j.attempts) &&
          Array.isArray(j.gifts)
        ) {
          gifts.attempts = [...j.attempts];
          gifts.gifts = [...j.gifts];
        }
      } catch (e) {}
    };
    const saveState = () => {
      try {
        if (!completeActions.length) {
          localStorage.removeItem("complete");
        } else {
          localStorage.setItem("complete", JSON.stringify(completeActions));
        }
      } catch (e) {}
      try {
        if (!gifts.attempts.length && gifts.gifts.length) {
          localStorage.removeItem("gifts");
        } else {
          localStorage.setItem("gifts", JSON.stringify(gifts));
        }
      } catch (e) {}
    };

    const getGiftsGroups = () => {
      const result = [];
      gifts.gifts.forEach((gift) => {
        result.push(gift.group);
      });
      return result;
    };

    const addGift = (gift) => {
      if (!gift.id) {
        return;
      }
      for (let i in gifts.gifts) {
        if (gifts.gifts[i].id == gift.id) {
          return; // avoid dup
        }
      }
      gifts.gifts.push(gift);
    };

    const requestLuckyItems = async (
      goalId,
      successCallback,
      errorCallback
    ) => {
      let success = false;
      let items = [];
      let gift = {};
      const errorCb = () => errorCallback && errorCallback();
      try {
        const response = await fetch(
          `/wp-json/mfa-blocks-actions2024/v1/stats/`,
          {
            headers: {
              "content-type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
              actions: completeActions.length,
              groups: getGiftsGroups(),
              attempts: gifts.attempts.length,
            }),
          }
        );
        if (response.ok) {
          const data = await response.json();
          if (!("gift" in data)) {
            errorCb();
            return false;
          }

          items = [...data.items];
          gift = { ...data.gift };

          if (goalId) {
            gifts.attempts.push(goalId);
          }
          if (gift.id) {
            addGift(gift);
          }
          saveState();

          success = true;
        }
      } catch (e) {}

      if (!success) {
        errorCb();
        return false;
      }

      successCallback(items, gift);
      return true;
    };

    const findGoalById = (goalId) => {
      if (typeof goalId === "object" && "id" in goalId) {
        return goalId;
      }
      for (let i in goals) {
        const goal = goals[i];
        if (goal.id === goalId) {
          return goal;
        }
      }
      return null;
    };

    const isGoalComplete = (goalId) => {
      const goal = findGoalById(goalId);
      if (!goal) {
        return false;
      }
      if (completeActions.length < goal.actions) {
        return false;
      }
      if (globalActionsTotal < goal.global) {
        return false;
      }
      return true;
    };

    const isGoalExpired = (goalId) => {
      const goal = findGoalById(goalId);
      if (!goal) {
        return true;
      }
      return gifts.attempts.indexOf(goal.id) > -1;
    };

    const getGoals = () => {
      const result = [];
      goals.forEach((goal) => {
        goal.isComplete = isGoalComplete(goal);
        goal.isExpired = isGoalExpired(goal);
        goal.updateStatus = () => {
          goal.isComplete = isGoalComplete(goal);
          goal.isExpired = isGoalExpired(goal);
        };
        result.push(goal);
      });
      // console.log(goals);
      // console.log(gifts.attempts);
      return result;
    };
    const getGiftList = () => [...gifts.gifts];

    return {
      loadState,
      clearState,
      saveState,
      completeAction,
      getActionsCounter,
      subscribeActionsCounter,
      subscribeGlobalActionsCounter,
      unsubscribeGlobalActionsCounter,
      isActionComplete,
      getGlobalActionsCounter,
      requestLuckyItems,
      getGoals,
      getGiftList,
      isGoalComplete,
      isGoalExpired,
    };
  };

  const routerFabric = (context) => {
    const list = [];
    let index = 0;

    const add = (screen) => {
      if (!screen) {
        return;
      }
      context.appendChild(screen);
      setTimeout(() => {
        screen.classList.add("ogvkhjhf3i5vu__screen--active");
      }, 1);
      setTimeout(() => {
        screen.tabIndex = -1;
        screen.focus();
      }, 400);
      if (screen.screenConstructor) {
        screen.screenConstructor();
      }
    };
    const remove = (screen) => {
      if (!screen) {
        return;
      }
      setTimeout(() => {
        screen.classList.remove("ogvkhjhf3i5vu__screen--active");
      }, 1);
      setTimeout(() => {
        screen.remove();
      }, 400);
      if (screen.screenDestructor) {
        screen.screenDestructor();
      }
    };

    const replace = (screen) => {
      const prev = list.pop();
      list.push(screen);
      remove(prev);
      add(screen);
      save();
      history.replaceState({ pageId: screen.templateId }, "", null);
    };

    const push = (screen) => {
      list.push(screen);
      index++;
      add(screen);
      save();
      history.pushState({ pageId: screen.templateId }, "", null);
    };

    const pop = () => {
      if (index <= 0) {
        return;
      }
      const prev = list.pop();
      index--;
      remove(prev);
      const screen = list[index];
      setTimeout(() => {
        screen.tabIndex = -1;
        screen.focus();
      }, 400);
      save();
    };

    const save = () => {
      try {
        const data = list.map((screen) => {
          return screen.templateId;
          // const entry = { id: screen.templateId };
          // if (Object.keys(screen.params).length)
          //   entry.params = { ...screen.params };
          // return entry;
        });
        localStorage.setItem("nav", JSON.stringify(data));
      } catch (error) {}
    };

    const load = () => {};

    window.addEventListener("popstate", (event) => {
      // const { state } = e.originalEvent;
      pop();
    });

    return {
      push,
      pop,
      replace,
      list,
    };
  };

  const useCasesFabric = (context, router, data) => {
    const createScreenFromTemplate = (templateId, params) => {
      const template = context.querySelector(
        `.ogvkhjhf3i5vu__screen-template[data-id=${templateId}]`
      );
      if (!template) {
        throw new Error(`Template "${templateId}" not found`);
      }
      const screen = template.cloneNode(true);
      screen.templateId = templateId;
      screen.params = params ? { ...params } : {};
      screen.screenConstructor = null;
      screen.screenDestructor = null;
      screen.classList.remove("ogvkhjhf3i5vu__screen-template");
      screen.classList.add("ogvkhjhf3i5vu__screen");
      return screen;
    };
    const openHomeScreen = () => {
      const screen = createScreenFromTemplate("home");
      bind(screen);
      router.replace(screen);
    };
    const openExtraScreen = () => {
      const screen = createScreenFromTemplate("extra");
      bind(screen);
      router.replace(screen);
    };
    const openAboutScreen = () => {
      const screen = createScreenFromTemplate("about");
      bind(screen);
      router.replace(screen);
    };
    const openScoreScreen = () => {
      const screen = createScreenFromTemplate("score");
      bind(screen);

      const loadGoals = () => {
        const target = screen.querySelector(
          ".ogvkhjhf3i5vu__main-score-container-goals"
        );

        const goals = data.getGoals();
        goals.forEach((goal) => {
          // goal container
          const div = document.createElement("div");
          div.className = "ogvkhjhf3i5vu__main-score-goal";

          // goal label
          const divLabel = document.createElement("div");
          divLabel.className = "ogvkhjhf3i5vu__main-score-goal-label";
          const { label1, label2, label3, and, action, actions } =
            target.dataset;
          const sp = goal.actions + goal.global != 1 ? actions : action;
          const label = `${goal.actions && !goal.global ? `${label1} ${goal.actions}` : !goal.actions ? `${label2} ${goal.global}` : `${label3} ${goal.actions} ${and} ${goal.global}`} ${sp}`;
          divLabel.innerText = label;
          div.appendChild(divLabel);

          // goal bars
          const addBar = (target, current, variation) => {
            if (target <= 0) {
              return;
            }
            const bar = document.createElement("div");
            bar.className = `ogvkhjhf3i5vu__main-score-goal-bar ogvkhjhf3i5vu__main-score-goal-bar--${variation}`;
            bar.updateBar = (current) => {
              bar.style.setProperty(
                "--p",
                Math.max(
                  0,
                  Math.min(100, Math.ceil((100 * current) / target))
                ) + "%"
              );
            };
            bar.updateBar(current);
            div.appendChild(bar);
            return bar;
          };
          let globalBar = null;
          if (goal.actions) {
            addBar(goal.actions, data.getActionsCounter(), "individual");
          }
          if (goal.global) {
            globalBar = addBar(
              goal.global,
              data.getGlobalActionsCounter(),
              "global"
            );
          }

          // lucky btn or label complete
          let btn;
          const removeButton = () => {
            if (btn) {
              btn.remove();
            }
          };
          const addLabelComplete = () => {
            if (
              div.querySelector(
                ".ogvkhjhf3i5vu__main-score-goal-label-complete"
              )
            ) {
              return;
            }
            const l = document.createElement("div");
            l.className = "ogvkhjhf3i5vu__main-score-goal-label-complete";
            l.innerText = target.dataset.labelcomplete;
            div.appendChild(l);
          };
          const refresh = () => {
            if (globalBar) {
              globalBar.updateBar(data.getGlobalActionsCounter());
            }
            goal.updateStatus();
            if (data.isGoalExpired(goal.id)) {
              removeButton();
              addLabelComplete();
            } else {
              if (btn) {
                btn.disabled = !data.isGoalComplete(goal.id);
              }
            }
          };
          const addButton = () => {
            btn = document.createElement("button");
            btn.className = "ogvkhjhf3i5vu__main-score-goal-btn-lucky";
            btn.innerHTML = `<span class="material-symbols-outlined" translate="no">featured_seasonal_and_gifts</span>`;
            const btnlb = document.createElement("span");
            btnlb.className = "ogvkhjhf3i5vu__main-score-goal-btn-lucky-label";
            btnlb.innerText = target.dataset.btnlabel;
            btn.appendChild(btnlb);
            if (!goal.isComplete) {
              btn.disabled = true;
            } else {
              btn.disabled = false;
            }
            btn.addEventListener("click", () => {
              openLuckyScreen({ goalId: goal.id, refresh });
            });
            div.appendChild(btn);
            btn.refresh = () => refresh();
          };
          if (!goal.isExpired) {
            addButton();
          } else {
            addLabelComplete();
          }

          target.appendChild(div);
        });
      };

      loadGoals();

      router.replace(screen);
    };
    const openGiftsScreen = () => {
      const screen = createScreenFromTemplate("gifts");
      bind(screen);

      const loadGiftList = () => {
        const target = screen.querySelector(
          ".ogvkhjhf3i5vu__main-gifts-giftlist"
        );
        const gifts = data.getGiftList();
        if (!gifts.length) {
          target.remove();
          return;
        }
        let count = 0;
        const list = target.querySelector(
          ".ogvkhjhf3i5vu__main-gifts-giftlist-list"
        );
        list.innerHTML = "";

        gifts.forEach((gift) => {
          if (!gift.id) {
            return;
          }
          count++;
          const item = document.createElement("div");
          item.className = "ogvkhjhf3i5vu__main-gifts-giftlist-list-item";
          const title = document.createElement("h3");
          title.className =
            "ogvkhjhf3i5vu__main-gifts-giftlist-list-item-title";
          title.innerText = gift.title;
          item.appendChild(title);
          if (gift.download_link) {
            const btn = document.createElement("a");
            Object.assign(btn, {
              className:
                "ogvkhjhf3i5vu__main-lucky-container-message-virtual-btn",
              target: "_blank",
              rel: "noopener",
              href: gift.download_link,
              innerHTML: `<span class="material-symbols-outlined" translate="no">open_in_new</span>
						<span class="ogvkhjhf3i5vu__main-lucky-container-message-virtual-btn-label">Acessar Brinde</span>`,
            });
            item.appendChild(btn);
          } else {
            const coupon = document.createElement("h3");
            coupon.className = "ogvkhjhf3i5vu__main-gifts-giftlist-coupon";
            const code = document.createElement("span");
            code.innerText = gift.code;
            coupon.appendChild(code);
            item.appendChild(coupon);
          }
          list.appendChild(item);
        });
        if (!count) {
          target.remove();
        }
      };
      loadGiftList();

      router.replace(screen);
    };
    const updateActionScreenButtonStateComplete = (screen) => {
      const completeBtn = screen.querySelector(
        ".ogvkhjhf3i5vu__footer-action-btn-complete"
      );
      completeBtn.classList.add(
        "ogvkhjhf3i5vu__footer-action-btn-complete--is-complete"
      );
    };
    const openActionScreen = (params) => {
      const screen = createScreenFromTemplate("action", params);
      const elTitle = screen.querySelector(".ogvkhjhf3i5vu__main-action-title");
      elTitle.innerText = params.title;
      const elDescription = screen.querySelector(
        ".ogvkhjhf3i5vu__main-action-description"
      );
      elDescription.innerHTML = params.description;
      const elET = screen.querySelector(
        ".ogvkhjhf3i5vu__main-action-estimated-time"
      );
      if (elET) {
        if (params.estimated_time) {
          const elETValue = elET.querySelector(
            ".ogvkhjhf3i5vu__main-action-estimated-time-value"
          );
          if (elETValue) {
            elETValue.innerText = params.estimated_time;
          }
        } else {
          elET.remove();
        }
      }
      const elBtn = screen.querySelector(".ogvkhjhf3i5vu__footer-action-btn");
      if (params.button_url) {
        elBtn.href = params.button_url;
        elBtn.querySelector(
          ".ogvkhjhf3i5vu__footer-action-btn-label"
        ).innerText = params.button_label;
      } else {
        elBtn.remove();
      }
      if (data.isActionComplete(params.id) || !params.button_url) {
        updateActionScreenButtonStateComplete(screen);
      }
      const hero = screen.querySelector(".ogvkhjhf3i5vu__main-action-hero");
      const heroImg = screen.querySelector(
        ".ogvkhjhf3i5vu__main-action-hero-img"
      );
      if (params.img) {
        heroImg.src = params.img;
      } else {
        hero.remove();
      }
      bind(screen);
      router.push(screen);
    };
    const openActionThankYouScreen = () => {
      const screen = createScreenFromTemplate("actionthankyou");
      bind(screen);

      const thankyouJson = screen.dataset.thankyou;
      const findAndSetOrRemove = (query, attributes) => {
        const el = screen.querySelector(query);
        if (el) {
          if (attributes !== false) {
            Object.assign(el, attributes);
          } else {
            el.remove();
          }
        }
      };

      let img = "",
        avatarname = "",
        message = "";
      try {
        const thankyou = JSON.parse(thankyouJson);
        if (thankyou && thankyou.length) {
          const index = data.getActionsCounter() % thankyou.length;
          const item = thankyou[index];
          img = item.img;
          avatarname = item.title;
          message = item.content;
        }
      } catch (e) {
        return false;
      }
      if (!message) {
        return false;
      }
      findAndSetOrRemove(
        ".ogvkhjhf3i5vu__main-action-thankyou-avatar-img",
        img ? { src: img } : false
      );
      findAndSetOrRemove(
        ".ogvkhjhf3i5vu__main-action-thankyou-avatarname",
        avatarname ? { innerText: avatarname } : false
      );
      findAndSetOrRemove(
        ".ogvkhjhf3i5vu__main-action-thankyou-message",
        message ? { innerText: message } : false
      );

      router.replace(screen);
      setTimeout(() => {
        const btn = screen.querySelector(
          ".ogvkhjhf3i5vu__footer-action-btn-thankyou"
        );
        if (btn) {
          btn.disabled = false;
        }
      }, 1000);
      return true;
    };

    const openLuckyScreen = (params) => {
      const screen = createScreenFromTemplate("lucky");
      bind(screen);

      const wheelContainer = screen.querySelector(
        ".ogvkhjhf3i5vu__main-lucky-container-wheel"
      );
      const wheel = screen.querySelector(".ogvkhjhf3i5vu__wheel-list");

      const hideLoading = () => {
        const loading = screen.querySelector(
          ".ogvkhjhf3i5vu__main-lucky-container-loading"
        );
        if (!loading) {
          return;
        }
        loading.remove();
      };

      const refreshParent = () => {
        if (params.refresh) {
          params.refresh();
        }
      };

      const enableButton = () => {
        const btn = screen.querySelector(
          ".ogvkhjhf3i5vu__footer-lucky-btn-continue"
        );
        if (!btn) {
          return;
        }
        btn.disabled = false;
      };

      data.requestLuckyItems(
        params.goalId,
        (items, gift) => {
          const buildItems = () => {
            items.forEach((item, idx) => {
              const label = document.createElement("span");
              const li = document.createElement("li");
              label.className = "ogvkhjhf3i5vu__wheel-list-item-label";
              label.innerText = item.i ? "" : item.l || idx;
              li.className = "ogvkhjhf3i5vu__wheel-list-item";
              li.appendChild(label);
              li.style.setProperty("--i", idx + 1);
              li.classList.add(`g${item.g}`);
              if (item.i) {
                li.classList.add(`inactive`);
              }
              wheel.appendChild(li);
            });
          };
          const canAnimate = window.matchMedia(
            "(prefers-reduced-motion: no-preference)"
          ).matches;
          const endRotation = "rotate(810deg)";
          const initialRotation = canAnimate
            ? `rotate(${Math.ceil(-180 - 180 * Math.random())}deg)`
            : endRotation;
          wheel.style.setProperty("--c", items.length);
          wheel.style.setProperty("transform", initialRotation);
          const showWheel = () => {
            wheelContainer.classList.add("loaded");
            setTimeout(() => {
              wheelContainer.classList.add("show");
            }, 1);
          };
          const hideWheel = () => {
            wheelContainer.classList.remove("show");
          };
          const removeWheel = () => wheelContainer.remove();
          const rotateWheel = (duration) => {
            if (!canAnimate) {
              return;
            }
            wheel.animate(
              [{ transform: initialRotation }, { transform: endRotation }],
              {
                duration,
                interations: 1,
                fill: "forwards",
                easing: "cubic-bezier(.22,0,.11,1.02)",
              }
            );
          };
          const showSuccess = () => {
            const div = screen.querySelector(
              !gift.id
                ? ".ogvkhjhf3i5vu__main-lucky-container-message-nogift"
                : gift.download_link
                  ? ".ogvkhjhf3i5vu__main-lucky-container-message-virtual"
                  : ".ogvkhjhf3i5vu__main-lucky-container-message-inventory"
            );
            if (gift.title) {
              const e = div.querySelector("[data-key=title]");
              if (e) e.innerText = gift.title;
            }
            if (gift.code) {
              const e = div.querySelector("[data-key=code]");
              if (e) e.innerText = gift.code;
            }
            if (gift.download_link) {
              const e = div.querySelector("[data-key=download_link]");
              if (e) e.href = gift.download_link;
            }
            div.classList.add("loaded");
            setTimeout(() => div.classList.add("show"), 1);
          };
          buildItems();
          hideLoading();
          showWheel();

          setTimeout(() => {
            const duration = canAnimate ? 7000 : 2000;
            rotateWheel(duration);

            setTimeout(() => {
              hideWheel();
            }, duration);
            setTimeout(() => {
              removeWheel();
              showSuccess();
              enableButton();
              refreshParent();
            }, duration + 400);
          }, 1000);
        },
        () => {
          hideLoading();
          enableButton();
          refreshParent();
          const error = screen.querySelector(
            ".ogvkhjhf3i5vu__main-lucky-container-error"
          );
          if (!error) {
            return;
          }
          error.classList.add("show");
        }
      );

      router.push(screen);
      return true;
    };
    const goBack = () => {
      router.pop();
    };

    const updateActionListStatuses = (actionList) => {
      // console.log("CALL updateActionListStatuses ");
      // console.log(actionList);
      actionList
        .querySelectorAll(".ogvkhjhf3i5vu__main-home-action")
        .forEach((element) => {
          const id = element.dataset.actionId;
          // console.log(`Action ${id}`);
          if (data.isActionComplete(id)) {
            // console.log(`Action ${id} is complete`);
            element
              .querySelectorAll(
                ".ogvkhjhf3i5vu__main-home-action-btn-completeicon"
              )
              .forEach((icon) => {
                // console.log(`Icon class added`);
                icon.classList.add(
                  "ogvkhjhf3i5vu__main-home-action-btn-completeicon--is-complete"
                );
              });
          }
        });
    };

    // const toggleFullscreen = (element) => {
    //   if (!document.fullscreenElement) {
    //     element.requestFullscreen();
    //   } else {
    //     document.exitFullscreen();
    //   }
    // };

    const bind = (screen) => {
      const forEach = (selector, cb) => {
        screen.querySelectorAll(selector).forEach(cb);
      };
      const bindClick = (selector, cb) => {
        forEach(selector, (el) => {
          el.addEventListener("click", cb);
        });
      };

      bindClick(".ogvkhjhf3i5vu__btn-action", (event) => {
        const el = event.target.closest(".ogvkhjhf3i5vu__btn-action");
        const params = el.dataset.action
          ? JSON.parse(el.dataset.action)
          : false;
        if (!params) {
          return;
        }
        openActionScreen(params);
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, 1000);
      });

      bindClick(".ogvkhjhf3i5vu__appbar-back", () => {
        goBack();
      });

      bindClick(".ogvkhjhf3i5vu__footer-btn[data-id=home]", () => {
        openHomeScreen();
      });

      bindClick(".ogvkhjhf3i5vu__footer-btn[data-id=extra]", () => {
        openExtraScreen();
      });

      bindClick(
        ".ogvkhjhf3i5vu__footer-btn[data-id=about], .ogvkhjhf3i5vu__appbar-mfalogo",
        () => {
          openAboutScreen();
        }
      );

      bindClick(".ogvkhjhf3i5vu__footer-btn[data-id=score]", () => {
        openScoreScreen();
      });

      bindClick(".ogvkhjhf3i5vu__footer-btn[data-id=gifts]", () => {
        openGiftsScreen();
      });

      forEach(".ogvkhjhf3i5vu__appbar-actionscounter", (el) => {
        data.subscribeActionsCounter((actionsCounter) => {
          el.innerText = actionsCounter;
        });
      });

      bindClick(".ogvkhjhf3i5vu__footer-action-btn", () => {
        updateActionScreenButtonStateComplete(screen);
      });

      bindClick(".ogvkhjhf3i5vu__footer-action-btn-complete", () => {
        const [success, isNew] = data.completeAction(screen.params.id);
        if (!isNew || !openActionThankYouScreen()) {
          goBack();
        }
      });

      bindClick(".ogvkhjhf3i5vu__footer-action-btn-thankyou", () => {
        goBack();
      });

      forEach(".ogvkhjhf3i5vu__main-home-container", (el) => {
        data.subscribeActionsCounter(() => {
          updateActionListStatuses(el);
        });
      });

      if (screen.templateId === "score") {
        const globalActionCounterWatcher = (counter) => {
          const bar = screen.querySelector(
            ".ogvkhjhf3i5vu__main-score-thermometer"
          );
          const elTotal = screen.querySelector(
            ".ogvkhjhf3i5vu__main-score-thermometer-base-value"
          );
          const goal1 = screen.querySelector(
            ".ogvkhjhf3i5vu__main-score-thermometer-goal1"
          );
          const goal2 = screen.querySelector(
            ".ogvkhjhf3i5vu__main-score-thermometer-goal2"
          );
          const goal3 = screen.querySelector(
            ".ogvkhjhf3i5vu__main-score-thermometer-goal3"
          );
          const goal4 = screen.querySelector(
            ".ogvkhjhf3i5vu__main-score-thermometer-goal4"
          );
          const goal5 = screen.querySelector(
            ".ogvkhjhf3i5vu__main-score-thermometer-goal5"
          );
          const total = counter;
          const cadence =
            total < 100 ? 100 : total < 200 ? 200 : total < 500 ? 500 : 1000;
          const roundUpTotal =
            cadence * Math.max(1, Math.ceil((total + 1) / cadence));
          const target = roundUpTotal;
          elTotal.innerText = total;
          goal1.innerText = target.toLocaleString("pt-BR");
          goal2.innerText = Math.round(target * 0.8).toLocaleString("pt-BR");
          goal3.innerText = Math.round(target * 0.6).toLocaleString("pt-BR");
          goal4.innerText = Math.round(target * 0.4).toLocaleString("pt-BR");
          goal5.innerText = Math.round(target * 0.2).toLocaleString("pt-BR");

          const progress = Math.min(1, total / Math.max(1, target));
          bar.style.setProperty("--progress", progress);

          screen
            .querySelectorAll(".ogvkhjhf3i5vu__main-score-goal-btn-lucky")
            .forEach((btn) => {
              if (!btn.refresh) {
                return;
              }
              btn.refresh();
            });
        };
        screen.screenConstructor = () => {
          data.subscribeGlobalActionsCounter(globalActionCounterWatcher);
        };
        screen.screenDestructor = () => {
          data.unsubscribeGlobalActionsCounter(globalActionCounterWatcher);
        };
        forEach(".ogvkhjhf3i5vu__main-score-user-total", (el) => {
          data.subscribeActionsCounter((actionsCounter) => {
            el.innerText = actionsCounter;
          });
        });
      }
    };

    return {
      openHomeScreen,
      openExtraScreen,
      openActionScreen,
      openActionThankYouScreen,
      openAboutScreen,
      openScoreScreen,
      openGiftsScreen,
      openLuckyScreen,
      goBack,
      bind,
      // toggleFullscreen,
    };
  };

  const runApp = (context) => {
    if (!document.body.classList.contains("block-editor-page")) {
      document.body.appendChild(context);
    }

    const router = routerFabric(context);
    const data = dataFabric(context);
    const useCases = useCasesFabric(context, router, data);
    data.loadState();
    useCases.openHomeScreen();

    // // Tests
    // const debug = () => {
    //   // data.clearState();
    //   // useCases.openGiftsScreen();
    //   setTimeout(() => {
    //     const btn = context.querySelector(
    //       ".ogvkhjhf3i5vu__screen--active .ogvkhjhf3i5vu__btn-action"
    //     );
    //     btn.click();
    //   }, 100);
    //   setTimeout(() => {
    //     const btn = context.querySelector(
    //       ".ogvkhjhf3i5vu__screen--active .ogvkhjhf3i5vu__footer-action-btn-complete"
    //     );
    //     btn.click();
    //   }, 500);

    //   setTimeout(() => {
    //     useCases.openScoreScreen();
    //   }, 700);
    //   setTimeout(() => {
    //     useCases.openLuckyScreen({
    //       goalId: 0,
    //       refresh: () => console.log("REFRESH"),
    //     });
    //   }, 900);
    //   // setTimeout(() => {
    //   //   const btn = context.querySelector(
    //   //     ".ogvkhjhf3i5vu__screen--active .ogvkhjhf3i5vu__btn-action"
    //   //   );
    //   //   btn.click();
    //   // }, 1600);
    //   // setTimeout(() => data.completeAction(1), 200);
    //   // setTimeout(() => data.completeAction(2), 300);
    //   // setTimeout(() => data.completeAction(1), 400);
    //   // setTimeout(() => useCases.openGiftsScreen(), 400);
    // };
    // debug();
  };

  const init = () => {
    document.querySelectorAll(".ogvkhjhf3i5vu").forEach((context) => {
      runApp(context);
    });
  };

  window.addEventListener("load", init);
})(document, window);
